export default "__VITE_ASSET__2949c80b__"